import type { ContentPack } from '../types';
import { hull_wedge } from './hulls/wedge';
import { hull_round } from './hulls/round';
import { hull_arrow } from './hulls/arrow';
import { hull_freighter } from './hulls/freighter';
import { hull_cross } from './hulls/cross';
import { hull_crab } from './hulls/crab';
import { hull_dreadnought } from './hulls/dreadnought';
import { hull_interceptor } from './hulls/interceptor';
import { hull_gunship } from './hulls/gunship';
import { cockpits } from './parts/cockpits';
import { wings } from './parts/wings';
import { engines } from './parts/engines';
import { weapons } from './parts/weapons';
import { muzzles } from './parts/muzzles';
import { exhausts } from './parts/exhausts';
import { wingtips } from './parts/wingtips';
import { noses } from './parts/noses';
import { CATEGORIES, STAT_DEFS } from './categories';
import { shipComputeStats } from './stats';

const hulls = { hull_wedge, hull_round, hull_arrow, hull_freighter, hull_cross, hull_crab, hull_dreadnought, hull_interceptor, hull_gunship };
const parts = { ...cockpits, ...wings, ...engines, ...weapons, ...muzzles, ...exhausts, ...wingtips, ...noses };

export const shipPack: ContentPack = {
  id: 'ships',
  version: 1,
  metadata: {
    title: 'SPRITE: SHIPS',
    namingLabel: 'Ship',
    filePrefix: 'sprite-ship',
    baseCategoryId: 'hull',
  },
  colorLabels: { primary: 'Hull', accent: 'Weapon', glow: 'Cockpit', detail: 'Engine', trim: 'Metal' },
  rasterSize: 64,
  hulls,
  parts,
  categories: CATEGORIES,
  stats: STAT_DEFS,
  compositeSlots: {
    wing_pair:    ['wing_left',    'wing_right'   ],
    engine_pair:  ['engine_left',  'engine_right' ],
    exhaust_pair: ['exhaust_left', 'exhaust_right'],
    wingtip_pair: ['wingtip_left', 'wingtip_right'],
  },
  renderOrder: ['wing', 'engine', 'exhaust', 'hull', 'cockpit', 'weapon', 'muzzle', 'nose', 'wingtip'],
  computeStats: shipComputeStats,
  defaultBuild: {
    hull: 'hull_wedge', cockpit: 'cockpit_bubble', wing: 'wing_swept',
    engine: 'engine_twin', weapon: 'weapon_cannon', muzzle: null,
    exhaust: 'exhaust_flame', wingtip: null, nose: null,
  },
};
